// extracted by mini-css-extract-plugin
module.exports = {"shadow":"GridButton_shadow__1QBS1","gridButton":"GridButton_gridButton__KTD8m"};